// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { SgSessionStorageService } from 'saga-modules';
import CommonConstants from 'sg-common-constants';

const {
    SG_ERROR_CODES
} = CommonConstants;

const {
    isQnB
} = appConfig;

let timeout;
let currentSessionUUID;
let lastRequestTime;
let lastRequestTimePreReload;

function setSession(model) {
    if (!isQnB) {
        return;
    }
    timeout = model.sessionUUIDTimeout_Ext * 60 * 1000; // DTO Timeout in min to ms
    currentSessionUUID = model.sessionUUID;
    lastRequestTime = Date.now();
    lastRequestTimePreReload = SgSessionStorageService.getItem(SgSessionStorageService.KEY.LAST_REQUEST_TIME);
    SgSessionStorageService.setItem(SgSessionStorageService.KEY.LAST_REQUEST_TIME, lastRequestTime);
    SgSessionStorageService.setItem(SgSessionStorageService.KEY.TIMEOUT, timeout);
}

function updateSession() {
    lastRequestTime = Date.now();
    SgSessionStorageService.setItem(SgSessionStorageService.KEY.LAST_REQUEST_TIME, lastRequestTime);
}

function clearSessionStorage() {
    SgSessionStorageService.removeItem(SgSessionStorageService.KEY.LAST_REQUEST_TIME);
    SgSessionStorageService.removeItem(SgSessionStorageService.KEY.TIMEOUT);
}

function restoreSessionAfterReload(model) {
    if (model.sessionUUID) {
        currentSessionUUID = model.sessionUUID;
    }
    if (SgSessionStorageService.getItem(SgSessionStorageService.KEY.TIMEOUT)) {
        timeout = SgSessionStorageService.getItem(SgSessionStorageService.KEY.TIMEOUT);
    }
    if (SgSessionStorageService.getItem(SgSessionStorageService.KEY.LAST_REQUEST_TIME)) {
        lastRequestTime = SgSessionStorageService.getItem(SgSessionStorageService.KEY.LAST_REQUEST_TIME);
    }
}

function isLastRequestOverTimeLimit(requestTime) {
    return (Date.now() - requestTime) >= SgSessionStorageService.getItem(SgSessionStorageService.KEY.TIMEOUT);
}

function handleErrorPage(model) {
    SgSessionStorageService.removeItem(SgSessionStorageService.KEY.MODEL);
    clearSessionStorage();
    const errorCode = SG_ERROR_CODES.SAGA_SESSION_TIMEOUT; // Timeout error
    const error = {
        appErrorCode: errorCode,
        baseError: {
            appErrorCode: errorCode
        },
        gwInfo: {
            params: [
                {
                    quoteID: model.quoteID
                }
            ]
        }
    };
    window.onunhandledrejection({
        reason: error,
    });
}

function isSessionValidAfterReload(model) {
    if (!model.sessionUUID) {
        return true;
    }
    if (lastRequestTimePreReload !== null && lastRequestTimePreReload !== undefined) {
        if (isLastRequestOverTimeLimit(lastRequestTimePreReload)) {
            handleErrorPage(model);
            lastRequestTimePreReload = undefined;
            return false;
        }
        restoreSessionAfterReload(model);
        return true;
    }
    return true;
}

function clearSession() {
    timeout = undefined;
    currentSessionUUID = undefined;
    lastRequestTime = undefined;
    lastRequestTimePreReload = undefined;
    SgSessionStorageService.clearSessionStorage();
}

function isSessionActive() {
    if (!isQnB) {
        return true;
    }
    return (Date.now() - lastRequestTime) <= timeout;
}

function isSessionValid(sessionUUID) {
    if (!isQnB) {
        return true;
    }
    lastRequestTimePreReload = undefined;
    if (timeout !== undefined && currentSessionUUID !== undefined) {
        if (currentSessionUUID === sessionUUID) {
            return isSessionActive();
        }
        console.error('SessionUUID missmatch');
    }
    return true;
}

function handleSession(model) {
    if (isSessionValid(model.sessionUUID) === false) {
        SgSessionStorageService.removeItem(SgSessionStorageService.KEY.MODEL);
        clearSessionStorage();
        const errorCode = SG_ERROR_CODES.SAGA_SESSION_TIMEOUT; // Timeout error
        const error = {
            appErrorCode: errorCode,
            baseError: {
                appErrorCode: errorCode
            },
            gwInfo: {
                params: [
                    {
                        quoteID: model.quoteID
                    }
                ]
            }
        };
        window.onunhandledrejection({
            reason: error,
        });
        return false;
    }
    return true;
}

export default {
    setSession,
    isSessionValidAfterReload,
    updateSession,
    handleSession,
    clearSession
};
